<template>
    <div class="category-container">
        <div class="cate-zone">
            <div class="cate-left" v-if="list.length>0">
                <div v-bind:key="item.title" :class="{active:currentIndex==index}" @click="selectCategory(index)" v-for="(item,index) in list" >{{item.title}}</div>
            </div>
            <div class="cate-right" v-if="list.length>0">
                <div v-show=" list[currentIndex].filter" class="r-filter">
                    <img class="f-img1" src="../assets/image/filter.png">
                    <p>筛选</p>
                    <img class="f-img2" src="../assets/image/arrow-blue-right.png">
                </div>
                <div v-bind:key="item.title" v-for="item in list[currentIndex].series" class="r-total">
                    <p class="series-title">{{item.title}}</p>
                    <div class="series-list clearfix">
                        <div v-bind:key="ser.title" @click="jump(ser.link)" v-for="ser in item.items" class="series-item">
                            <img class="s-img" :src="ser.image">
                            <p class="s-p">{{ser.title}}</p>
                        </div>
                        <div @click="jump(item.more)" v-show="item.more" class="series-item">
                            <p class="s-p">更多...</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      <filter-component v-on:fadeway="fadeFilter" :show='isShowFilter' :level-one-items='filterList' :products='products' ></filter-component>
    </div>
</template>
<style>
</style>
<script>
import cData from "../assets/json/category";
import FilterComponent from "./common/FilterComponent";
import LINKTYPE from "../commons/utils/linktype.js";
import pim from "../commons/utils/pim.js";

export default {
  data() {
    return {
      api: this.$store.state.api,
      list: [],
      currentIndex: 0,
      BASE_URL: BASE_URL
    };
  },
  created() {
    this.getData();
  },
  components: {
    FilterComponent
  },
  methods: {
    async getData() {
      this.list = await pim.categoryList(true);
      if (this.$router.currentRoute.query.index) {
        this.currentIndex = this.$router.currentRoute.query.index;
      }
    },
    jump(link) {
      if (link) {
        this.$router.push({
          path: "ProductList",
          query: {
            path: link
          }
        });
      }
    },
    selectCategory(index) {
      this.currentIndex = index;
      this.$router.push({
        path: "/Category",
        query: { index: this.currentIndex }
      });
      //console.log(this.currentIndex);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Category.vue